// Skysight keys its map overlay tiles by LOCAL time: at 14:00 local (12:00 UTC)
// it requests `.../1400/...`. But our `url.time` is stored UTC (to match the
// skewt/point/windgram APIs, which ARE UTC). So before building an overlay tile
// URL we must convert the UTC HHMM to the viewer-local HHMM. DST-correct via the
// JS Date object (same approach as ForecastTopBar's local-time label).
export const utcHHMMToLocalHHMM = (date, utcHHMM) => {
    if (typeof utcHHMM !== 'string' || utcHHMM.length !== 4) return utcHHMM;
    const dateStr = typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
        ? date
        : null;
    if (!dateStr) return utcHHMM;
    const d = new Date(`${dateStr}T${utcHHMM.slice(0, 2)}:${utcHHMM.slice(2)}:00Z`);
    if (Number.isNaN(d.getTime())) return utcHHMM;
    return String(d.getHours()).padStart(2, '0') + String(d.getMinutes()).padStart(2, '0');
};
